<template>
  <g>
    <path
      d="M12.56 14.3302C12.22 14.6002 12 15.0302 12 15.5002V21.0002H19C20.1 21.0002 21 20.1002 21 19.0002V13.0202C20.06 12.6902 19.05 12.5002 18 12.5002C15.97 12.5002 14.07 13.2002 12.56 14.3302Z"
    />
    <path
      d="M18 11.0002C20.7614 11.0002 23 8.76161 23 6.00018C23 3.23876 20.7614 1.00018 18 1.00018C15.2386 1.00018 13 3.23876 13 6.00018C13 8.76161 15.2386 11.0002 18 11.0002Z"
    />
    <path
      d="M11.5 6.00018C11.5 4.92018 11.77 3.90018 12.24 3.00018H5C3.9 3.00018 3 3.90018 3 5.00018V19.0002C3 19.5502 3.23 20.0502 3.59 20.4102L13.41 10.5902C12.23 9.42018 11.5 7.80018 11.5 6.00018Z"
    />
  </g>
</template>
